import './RecruitmentLanding.scss'
import { ReactComponent as JCRLogo } from '../../../assets/jcr-logo.svg'
import { useToggle } from '../../../hooks'
import LateralHiring from '../Components/lateral-hiring/LateralHiring'
import OtpModal from '../Components/otp-modal/OtpModal'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from "../../../config/routes"
import { useDispatch } from 'react-redux'
import { resetAllRecruitmentData } from '../RecruitmentDataSlice'
import { useEffect } from 'react'
import { resetUserCredentials } from '../../login-page/LoginAuthSlice'
import { useUserLogoutMutation } from '../../../services/userAuth'



const RecruitmentLanding = () => {
  const [logout] = useUserLogoutMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [showOtpModal, setShowOtpModal] = useToggle(false)

  const handleFormOnSubmit = async () => {
    setShowOtpModal()
  }
  const handleOtpSubmit = async () => {
    setShowOtpModal()
    navigate(`${ROUTES.RECRUITMENT}/${ROUTES.ONBOARDING}/${ROUTES.BASIC_DETAILS}`)
  }

  useEffect(() => {
    dispatch(resetAllRecruitmentData());
    dispatch(resetUserCredentials());
    logoutUser()
  }, [])

  const logoutUser = async () => {
    await logout()
  }


  return (
    <div className='RecruitmentLanding text-white flex flex-column justify-content-center align-items-center'>
      <OtpModal visible={showOtpModal} onHide={setShowOtpModal} handleOtpSubmit={handleOtpSubmit} />
      <div className="flex flex-column align-items-center">
        <JCRLogo height="1.5rem" className="my-2" />
        <h2 className='font-bold text-5xl mb-0'>Welcome to the team!</h2>
        <p className='text-lg mb-6 mt-0'>Your journey with us starts here</p>
      </div>
      <div className="RecruitmentFormWrapper px-5 py-6 w-11 md:w-6 mx-auto">
        <LateralHiring handleOnSubmit={handleFormOnSubmit} />
      </div>
    </div>
  )
}

export default RecruitmentLanding